module.exports = __webpack_public_path__ + "img/clouds-hero-background.4607ab9f.jpg";